import { mapActions, mapGetters } from 'vuex'
import { CacheHelper } from '@/helpers/CacheHelper'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'

export const PostcodeSearchMixin = {
  mixins: [SelectedSiteIdMixin],
  data () {
    return {
      error: '',
      postcode: '',
      timeoutId: null
    }
  },
  computed: {
    ...mapGetters('PostcodeSearches', [
      'findPostcodeSearch'
    ]),
    postcodeSearch () {
      return this.findPostcodeSearch(this.postcodeSearchKey)
    },
    postcodeSearchModel () {
      return {
        postcode: this.postcode.toLowerCase().split(' ').join('')
      }
    },
    postcodeSearchModelValid () {
      return this.postcodeSearchModel.postcode.length > 4
    },
    postcodeSearchKey () {
      return CacheHelper.getObjectCacheKey(this.postcodeSearchModel)
    },
    addresses () {
      return this.postcodeSearch ? this.postcodeSearch.values : []
    },
    searchingPostcode () {
      return this.postcodeSearch && this.postcodeSearch.loading
    },
    showPostcodeResults () {
      return this.postcodeSearch && !this.searchingPostcode
    }
  },
  watch: {
    postcode () {
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(() => {
        this.refreshPostcodeSearch()
      }, 500)
    }
  },
  methods: {
    ...mapActions('PostcodeSearches', [
      'searchPostcodeBySiteId'
    ]),
    refreshPostcodeSearch () {
      if (!this.postcodeSearch || this.postcodeSearch.retry) {
        this.trySearchPostcodeBySiteId()
      }
    },
    trySearchPostcodeBySiteId () {
      const self = this
      if (!this.postcodeSearchModelValid) {
        return
      }
      self.error = ''
      self.searchPostcodeBySiteId({ key: self.postcodeSearchKey, siteId: self.selectedSiteId, payload: self.postcodeSearchModel })
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  }
}
